if( window.location.href.includes("add-subscription") )
{
    var selectionData = {};
    selectionData.taxTotal = 0;
    selectionData.taxRate = 0;
    selectionData.taxCounty = null;
    selectionData.drinkStocked = 1;
    selectionData.collectionAddons = {};

    var pricingData;

    jQuery(document).ready(function ($) {
        pricingData = JSON.parse( jQuery("#prices").val() );
        selectionData.addDrink = 0;
        selectionData.currencyUnit = jQuery("#currencyUnit").val();
        selectionData.drinkPrice = jQuery("#drinkPrice").val();
        
        // Step Flavor
        jQuery('.flavor-btn').on('click', function (e) {
            e.preventDefault();
            // toggle class
            jQuery('.flavor-btn').removeClass('active');
            jQuery(this).toggleClass('active');

            // enable continue button on selection
            $('#nextStepPlan').removeAttr("disabled");
        });
        $("#nextStepPlan").on('click', function (e) {
            $(`#stepPlan`).removeClass("d-none");
            $(`#stepFlavor`).addClass("d-none");
            setProgressBar(1);

            selectionData.flavor = jQuery("button.flavor-btn.active").data('flavor-type');
        });

        // Step Size
        $(".card-size").on('click', function (e) {
            $('#nextStepTerm').removeAttr("disabled");
        });

        $("#nextStepTerm").on('click', function (e) {
            $(`#stepTerm`).removeClass("d-none");
            $(`#stepPlan`).addClass("d-none");
            setProgressBar(2);

            selectionData.size = $(".card-size.active").first().data('sizename');
            selectionData.boxSize = $(".card-size.active").first().data('sizecode');

            jQuery("#term_price_1").text( pricingData[selectionData.boxSize][1] );
            jQuery("#term_price_6").text( pricingData[selectionData.boxSize][6] );
            jQuery("#term_price_12").text( pricingData[selectionData.boxSize][12] );
        });

        // Step Term
        $(".card-term").on('click', function (e) {
            e.preventDefault();
            // toggle class
            jQuery('.card-term').removeClass('active');
            jQuery(this).toggleClass('active');

            // enable continue button on selection
            $('#nextStepCountry').removeAttr("disabled");
        });

        var allCountries = JSON.parse( $("#countryArray").val() );

        initializePaymentEditor(jQuery);



        // enable continue buts when selection is made

        // temp commenting this out  since the logic changed

        $(".card-size").click(function () {
            // $('#nextStepTerm').removeAttr("disabled");

            $("#flagContainer").empty();

            let key = $(this).data('sizename') + "Mix";

            allCountries[key].forEach(function( country ) {
                let countryText = `<button id="unique-${country.id}"
                    class="countryFlag"
                    data-drinkstocked="${country.DrinkStocked}"
                    data-countryname="${country.Country}"
                    data-countryimage="${country['Flag URL']}"
                    data-crateimage="${country['crate img']}"
                    style="background-image: url('${country['Flag URL']}')"
                    title="${country.Country}"
                    onclick="selectCountry(this)"
                >
                </button>`;

                $("#flagContainer").append(countryText);
            });
        });

        // continue buttons
        setProgressBar(0);

        $("#nextStepCountry").on('click', function (e) {
            $(`#stepCountry`).removeClass("d-none");
            $(`#stepTerm`).addClass("d-none");
            setProgressBar(3);

            selectionData.term = $(`#termStep .option-interaction.active`).data('term');
            selectionData.basePrice = pricingData[selectionData.boxSize][selectionData.term];
            selectionData.totalPrice = selectionData.basePrice;

            let termText = selectionData.term == 1 ? 'Monthly' : selectionData.term + ' Month';
            $("#termText").text(termText);

            $("#sizeText").text(selectionData.size + " Size");

            updatePriceTotals();

            if( $("#flagContainer .countryFlag").length == 1 )
            {
                $("#flagContainer .countryFlag").first().click();//addClass('active');
                $("#nextStepDrink").click();
            }
        });

        $("#nextStepDrink").on('click', function (e) {
            $(`#stepDrink`).removeClass("d-none");
            $(`#stepCountry`).addClass("d-none");

            selectionData.drinkStocked = $(".countryFlag.active").first().data("drinkstocked");

            if( selectionData.drinkStocked == 0 )
            {
                $("#nextStepCheckout,#deleteDrink").click();
                selectionData.addDrink = 0;
                updatePriceTotals();
            }

            setProgressBar(4);
        });

        // shop snack collections add to order/remove from order
        jQuery('.add-collection').on('click', function(e) {
            jQuery(e.currentTarget)
                .removeClass('d-flex')
                .addClass('d-none')
                .next('.remove-collection').addClass('d-flex').removeClass('d-none');

            let collectionElement = jQuery(e.currentTarget).closest(".single-collection");
            let collectionObject = {
                candybarId: jQuery(collectionElement).data('cbpostid'),
                accountId: jQuery(collectionElement).data('accountpostid'),
                crateSize:  jQuery(collectionElement).data('size'),
                price:  jQuery(collectionElement).data('price'),
                name: jQuery(collectionElement).data('name'),
                productName: jQuery(collectionElement).data('fulfillmentname'),
                crateImage: jQuery(collectionElement).data('crateimage')
            };

            selectionData.collectionAddons[collectionObject.candybarId] = collectionObject;

            let collectionSummaryHtml = `
            <div id="collection_${collectionObject.candybarId}" class="px-0 pb-3 d-flex justify-content-between">
                <span>
                    <div class="font-weight-bold mb-0 collection-name">${collectionObject.name}</div>
                    <button id="removeCollection_${collectionObject.candybarId}" class="btn-remove removeDrinkBtn">Remove</button>
                </span>

                <div id="offerPrice" class="text-gray font-weight-normal">$${collectionObject.price}</div>
            </div>
            `;

            jQuery("#additional-snacks").addClass("d-block");
            jQuery("#subscribeCollections").append(collectionSummaryHtml);

            jQuery(`#removeCollection_${collectionObject.candybarId}`).on('click', function() {
                jQuery(`.single-collection[data-cbpostid='${collectionObject.candybarId}'] .remove-collection`).click();
            });

        });
        jQuery('.remove-collection').on('click', function(e) {
            jQuery(e.currentTarget)
                .removeClass('d-flex')
                .addClass('d-none')
                .prev('.add-collection').addClass('d-flex').removeClass('d-none');

            let collectionElement = jQuery(e.currentTarget).closest(".single-collection");

            let collectionElementKey = jQuery(collectionElement).data('cbpostid');
        
            delete selectionData.collectionAddons[collectionElementKey];

            jQuery(`#collection_${collectionElementKey}`).remove();

            if( jQuery.isEmptyObject(selectionData.collectionAddons) )
            {
                jQuery("#additional-snacks").addClass("d-none").removeClass("d-block");
            }

            updatePriceTotals();
        });

        $("#nextStepCheckout").on('click', function (e) {
            $(`#stepCheckout`).removeClass("d-none");
            $(`#stepDrink`).addClass("d-none");
            setProgressBar(5);

            updatePriceTotals();
        });

        // back buttons
        $("#backToFlavor").on('click', function (e) {
            $(`#stepPlan`).addClass("d-none");
            $(`#stepFlavor`).removeClass("d-none");
            setProgressBar(0);
        });

        $("#backToPlan").on('click', function (e) {
            $(`#stepTerm`).addClass("d-none");
            $(`#stepPlan`).removeClass("d-none");
            setProgressBar(1);
        });

        $("#backToTerm").on('click', function (e) {
            $(`#stepCountry`).addClass("d-none");
            $(`#stepTerm`).removeClass("d-none");
            setProgressBar(2);
        });

        $("#backToCountry").on('click', function (e) {
            $(`#stepDrink`).addClass("d-none");
            $(`#stepCountry`).removeClass("d-none");
            setProgressBar(3);

            if( $("#flagContainer .countryFlag").length == 1 )
            {
                console.log('here');
                $("#backToTerm").click();
            }
        });

        $("#backToDrink").on('click', function (e) {
            $(`#stepCheckout`).addClass("d-none");
            $(`#stepDrink`).removeClass("d-none");
            setProgressBar(4);

            if( selectionData.drinkStocked == 0 )
            {
                $("#backToCountry").click();
            }
        });

        $("#subAddDrink").on('click', function (e) {
            $(this).addClass('d-none');
            $('.remove-drink-container').removeClass('d-none');
            selectionData.addDrink = 1;
            
            updatePriceTotals();

            $("#drinkAddition").removeClass("d-none");
            
        });

        $("#subRemoveDrink, #deleteDrink").on('click', function (e) {
            $('.remove-drink-container').addClass('d-none');
            $('#subAddDrink').removeClass('d-none');
            selectionData.addDrink = 0;

            updatePriceTotals();

            $("#drinkAddition").addClass("d-none");
            
        });

        $("#firstName, #lastName, #addressLineOne, #city, #state, #postal").on('change', function() {
            if(
                $("#firstName").val().length > 0 &&
                $("#lastName").val().length > 0 &&
                $("#addressLineOne").val().length > 0 &&
                $("#city").val().length > 0 &&
                ($("#state").length == 0 || $("#state").val().length > 0) &&
                $("#postal").val().length >= 5
            )
            {
                $("#subscribebtn, #placeOrder").attr("disabled", false);
            }
            else
            {
                $("#subscribebtn, #placeOrder").attr("disabled", "disabled");
            }
        });

        $("#state, #postal").on('change', function(e) {

            if( $("input[name='country']").val() == 'United States of America' && $("#state").val() == 'Florida' && $('#postal').val().length >= 5 )
            {
                jQuery.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    type: "POST",
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('csrf_token', jQuery('meta[name="csrf-token"]').attr('content'));
                    },
                    data: {
                        'zip': jQuery("#postal").val(),
                        'action': 'sc_get_tax',
                    },
                    dataType: 'json',
                    success: function(response) {
                        selectionData.taxRate = response.data.results[0].taxSales;
                        selectionData.taxCounty = response.data.results[0].geoCounty;
                        updatePriceTotals();
                    }
                });
            }

        });

        $("#subscribe-snacker").on('submit', function(e) {
            e.preventDefault();

            $("#subscribebtn, #placeOrder").attr("disabled","disabled");
            
            jQuery('.loading_wrapper').fadeIn();

            let postData = selectionData;
            postData.drinkAddon = selectionData.addDrink == 1 ? 'on' : false;
            postData.flavor = selectionData.flavor;
            postData.shipping_name = $("#firstName").val() + ' ' + $("#lastName").val();
            postData.birthday = null;
            postData.address = $("#addressLineOne").val();
            postData.suite = $("#addressLineTwo").val();
            postData.city = $("#city").val();
            postData.state = $("#state").val();
            postData.zip = $("#postal").val();
            postData.country = $("#userCountry").val();
            postData.action = "add_subscription";
            postData.pay_method = $("#payMethod").val();
            
            submitAjaxForm( $("#subscribe-snacker").attr("action"), postData, $("#alertcontainerNewSub") );
        });

        $("#placeOrder").on('click', function() {
            $("#subscribe-snacker").submit();
        });

        function equalHeight(resize) {
            var elements = document.getElementsByClassName("equalHeightCollection"),
                allHeights = [],
                i = 0;
            if(resize === true){
                for(i = 0; i < elements.length; i++){
                    elements[i].style.height = 'auto';
                }
            }
            for(i = 0; i < elements.length; i++){
                var elementHeight = elements[i].clientHeight;
                allHeights.push(elementHeight);
            }
            for(i = 0; i < elements.length; i++){
                elements[i].style.height = Math.max.apply( Math, allHeights) + 'px';
                // Optional: Add show class to prevent FOUC
                if(resize === false){
                    elements[i].className = elements[i].className + " show";
                }
            }
        }

    });

    function selectCountry(countryElement)
    {
        selectionData.firstCountry = countryElement.dataset.countryname;
        selectionData.firstCountryCrateImg = countryElement.dataset.crateimage;

        jQuery(countryElement).siblings().removeClass('active');
        jQuery(countryElement).addClass('active');

        jQuery('#nextStepDrink').removeAttr("disabled");

        jQuery("#monthly-sub__country").text( selectionData.firstCountry + " Box");
        jQuery("#countryImage").attr('src', countryElement.dataset.countryimage);
    }

    function updatePriceTotals()
    {
        jQuery("#monthly-sub__totalPrice").text(selectionData.basePrice);

        let subtotal = selectionData.addDrink == 1 ? parseFloat(selectionData.basePrice) + parseFloat(selectionData.drinkPrice) : parseFloat(selectionData.basePrice);

        let monthlyTotal = selectionData.addDrink == 1 ? parseFloat(selectionData.basePrice) + parseFloat(selectionData.drinkPrice) : parseFloat(selectionData.basePrice);//(subTotal * selectionData.taxRate).toFixed(2);
        monthlyTotal += monthlyTotal * selectionData.taxRate;
        monthlyTotal = monthlyTotal.toFixed(2);

        if( 'collectionAddons' in selectionData )
        {
            Object.entries(selectionData.collectionAddons).forEach( function( collection ) {
                subtotal += parseFloat(collection[1].price);
                //taxTotal += parseFloat(collection[1].price * selectionData.taxRate);
            });
        }

        subtotal = subtotal.toFixed(2);

        let taxTotal = (subtotal * selectionData.taxRate).toFixed(2);

        jQuery("#subTotalPrice").text(subtotal);

        let grandTotal = parseFloat(subtotal) + parseFloat(taxTotal);

        grandTotal = grandTotal.toFixed(2);

        jQuery("#taxPrice").text(taxTotal);

        jQuery("#totalPrice, #totalPriceMobile").text(grandTotal);
        jQuery("#userBillingMonthlyPrice").text(monthlyTotal);
        jQuery("#monthly-sub__totalPrice, #subTotalPrice, #taxPrice, #totalPrice, #totalPriceMobile, #userBillingMonthlyPrice").prepend(selectionData.currencyUnit);
    }
    

    // Change progress bar action
    function setProgressBar(curStep) {
        var percent = parseFloat(100 / 5) * curStep;
        percent = percent.toFixed();
        jQuery(".progress-bar")
            .css("width", percent + "%");
        jQuery(window).scrollTop(0);
    }
}

function initializePaymentEditor($)
{
    // toggle payment method options
    $(".payment-info[data-method]").click(function () {
        $('.active').not(this).removeClass('active');
        $(this).addClass('active');

        $('#payMethod').val( jQuery(this).data('method') );
    });

    $("#usePayment").on('click', function(e) {
        $("input[name='pay_method']").val( $(".payment-info.active").data('method') );

        $("#userCardName").text( $(".payment-info.active .card-name").text() );
        
        let brand = $(".payment-info.active .card-brand").data('brand');
        let brandImgSrc = $("#userCardBrand").attr("src").replace( /[^/]*$/.exec($("#userCardBrand").attr("src"))[0], brand.replace(' ','') + ".png" );
        $("#userCardBrand").attr('alt', brand + ' logo' ).attr('src', brandImgSrc);
        
        $("#userLastFour").text( $(".payment-info.active .card-last4").text() );
        $("#userCardExpDate").text( $(".payment-info.active .card-exp-date").text() );
    });
}